// src/store/index.ts
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import premiumReducer from './premiumSlice';
import uiReducer from './uiSlice';
import formDraftReducer from './formDraftSlice';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

/* ------------- ① Root Reducer ------------- */
const rootReducer = combineReducers({
  ui: uiReducer,
  premium: premiumReducer,
  formDraft: formDraftReducer
});

/* ------------- ② 永続化設定 ------------- */
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['ui', 'premium', 'formDraft'] // formDraft を追加して入力内容を保持
  /* 
     premium だけを残すと featurePanelOpen が保存されません。
     ui Slice 全体を whitelist に含めれば、featurePanelOpen も
     その他 UI 状態も自動的に復元されます。
  */
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

/* ------------- ③ Store ------------- */
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

/* ------------- ④ 型エクスポート ------------- */
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
